import gql from 'graphql-tag';

export default gql`
     mutation($organizationId: String!, $merchantId: String!, $clientId: String!, $email: String!) {
         createBillingLink(organizationId: $organizationId, merchantId: $merchantId, clientId: $clientId, email: $email)
    }
`;
